module.exports = __webpack_public_path__ + "img/Bitmap@2x2 (1).d501c28a.png";